import { render, staticRenderFns } from "./AssignModeratorDailog.vue?vue&type=template&id=4662db88&v-bind=%24props"
import script from "./AssignModeratorDailog.vue?vue&type=script&lang=js"
export * from "./AssignModeratorDailog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports